module.exports = __webpack_public_path__ + "media/recipes/158-4fc5790d.png";